import { Component } from '@angular/core';
import { BaseFormValidationMessagesComponent } from '../base-form-validation-messages.component';
import { PatternsErrorKeys } from '@foxeet/domain';

@Component({
  selector: 'ui-mobile-form-validation-messages',
  templateUrl: './form-validation-messages.component.html',
  styleUrls: ['./form-validation-messages.component.scss'],
})
export class FormValidationMessagesComponent extends BaseFormValidationMessagesComponent {
  // TODO add wrongInput to @iv/core
  displayWrongInputError = (): boolean => this.generalDisplayError('wronInput');
  displayIsNotValidError = (): boolean => this.generalDisplayError('isNotValid');
  displayPostalCodeFormatError = (): boolean => this.generalDisplayError(PatternsErrorKeys.POSTAL_CODE_FORMAT);
  displayPostalCodeProvinceError = (): boolean => this.generalDisplayError(PatternsErrorKeys.POSTAL_CODE_PROVINCE);
  displayIdentityDocumentFormatError = (): boolean => this.generalDisplayError(PatternsErrorKeys.IDENTITY_DOCUMENT_FORMAT);
}
